import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BasePageComponent } from '../../base-page.component';
import { InspectionService } from '../../shared/services';
import { Inspection, InspectionRestoreItem } from '../../shared/models';
import { InspectionRestoreListMenuComponent } from '../../menus/restore-list.menu';

@Component({
    templateUrl: './restore-list.component.html',
    standalone: false
})
export class InspectionRestoreListPageComponent extends BasePageComponent implements OnInit {
  public inspectionId: string;
  public inspection: Inspection;
  public items: InspectionRestoreItem[];
  constructor(
    public inspectionService: InspectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.router.navigate([this.inspectionsRoute]);
      }

      this.inspectionId = id;
      this.initData();
    });
  }

  initData(): void {
    this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
      this.inspection = el;
    });
    this.inspectionService.getInspectionRestoreItems(this.inspectionId).subscribe((items) => {
      this.items = items;
    });
  }

  public openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open(InspectionRestoreListMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.restore();
        break;
      default:
    }
  }

  public restore() {
    this.inspectionService
      .restoreInspectionItems(
        this.inspectionId,
        this.items.filter((item) => (<any>item).selected)
      )
      .subscribe((data) => {
        this.goToBack();
      });
  }

  public selectItem(item: any) {
    item.selected = !item.selected;
  }

  goToBack(): void {
    this.router.navigate([this.inspectionsRoute, this.inspectionId]);
  }
}
